import { SelectItem } from '@/_components';

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 12);

const ADJUSTED_YEAR = currentDate.getFullYear();

export const CURRENT_TAX_YEAR: string = ADJUSTED_YEAR.toString();

export const TAX_YEARS: Array<SelectItem> = [
  { name: '2025', value: '2025' },
  { name: '2024', value: '2024' },
  { name: '2023', value: '2023' },
  { name: '2022', value: '2022' },
  { name: '2021', value: '2021' },
  { name: '2020', value: '2020' },
  { name: '2019', value: '2019' },
  { name: '2018', value: '2018' },
];

export const TAX_YEARS_WITHOUT_DEFAULT: Array<SelectItem> = [
  { name: 'Select Year', value: '' },
  ...TAX_YEARS,
];
